module.exports = __webpack_public_path__ + "img/soster1_v2.6fae312d.png";